import { SVGAttributes } from "react";

export const ItemStackIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.502 11.44a1 1 0 011.401-.188l7.488 5.726a.12.12 0 00.024.01.29.29 0 00.085.012.29.29 0 00.084-.012c.016-.005.023-.01.025-.01l7.487-5.726a1 1 0 111.215 1.59l-7.489 5.726c-.753.576-1.891.576-2.645 0L3.688 12.84a1 1 0 01-.186-1.402z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.502 15.393a1 1 0 011.401-.187l7.488 5.725c.001.001.009.005.024.01a.29.29 0 00.194-.01l7.487-5.725a1 1 0 111.215 1.588l-7.489 5.727c-.753.576-1.891.576-2.645 0l-7.489-5.727a1 1 0 01-.186-1.402z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 4.197L6.873 8.5l5.627 4.303L18.127 8.5 12.5 4.197zm.715-1.97c-.395-.303-1.035-.303-1.43 0L4.296 7.953c-.395.302-.395.792 0 1.094l7.489 5.726c.395.303 1.035.303 1.43 0l7.489-5.726c.395-.302.395-.792 0-1.094l-7.489-5.726z"
        fill="currentColor"
      />
    </svg>
  );
};
ItemStackIcon.displayName = "ItemStackIcon";
